<template>
    <v-flex xs6 ma-1>
        <v-card>
            <v-card-text>
               
                <v-layout row>
                    <v-btn :href="invoicingUrl"><v-icon>attach_money</v-icon> Invoicing</v-btn>
                    <v-btn :href="receiptsUrl"><v-icon>attach_money</v-icon> Receipts</v-btn>
                    <v-btn :href="refundsUrl"><v-icon>attach_money</v-icon> Refunds & Adjustments</v-btn>
                    <v-btn :href="vouchersUrl"><v-icon>card_giftcard</v-icon> Vouchers</v-btn>
                    <v-btn :href="reportsUrl"><v-icon>show_chart</v-icon> Reports</v-btn>
                    <v-btn :href="filesUrl" disabled><v-icon>download</v-icon> Files</v-btn>
                </v-layout>
                
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    /**
     * Display buttons linking through to accounts reports
     */
    export default {
        props:[],

        data: function() {
            return {
                invoicingUrl: "/accounts/invoices",
                receiptsUrl: "/accounts/receipts",
                refundsUrl: "/accounts/refunds",
                vouchersUrl: "/accounts/vouchers",
                reportsUrl: "/accounts/reports",
                filesUrl: "/accounts/files",
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){},

        methods: {},

        computed: {}
    }
</script>
